<template>
  <div style='position:relative;width:700px;'>
    <el-input placeholder="输入关键字进行过滤" v-model="filterText"
              style='margin-bottom: 1rem;' size='mini'
              :clearable="true" />
    <div :style='{height: height, overflow:"auto"}'>
      <el-tree ref='tree'
               node-key="id"
               :show-checkbox='false'
               :data="data"
               :check-strictly='true'
               :default-expand-all='true'
               :check-on-click-node='true'
               :expand-on-click-node='false'
               :indent='16'
               :props='props'
               :filter-node-method="filterNode"
               @check='handleCheck'
               @node-contextmenu='showContexmenu' />
    
      <el-dropdown class='el-dropdown cx-tree-checkbox-el-dropdown' @command='handleContextMenu'
                  size='medium' placement="bottom" @visible-change='handleDropdownVC'
                  ref='dropdown'>
        <span class="el-dropdown-link" />
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command='add_menu' v-if='contextMenuType===1 || contextMenuType===2'>新增同级菜单</el-dropdown-item>
          <el-dropdown-item command='add_submenu' v-if='contextMenuType==1'>新增子级菜单</el-dropdown-item>
          <el-dropdown-item command='modify_menu' v-if='contextMenuType===1 || contextMenuType===2'>修改此菜单</el-dropdown-item>
          <el-dropdown-item command='delete_menu' v-if='contextMenuType===1 || contextMenuType===2'>删除此菜单</el-dropdown-item>
          <el-dropdown-item command='add_perm' v-if='contextMenuType===2'>新增权限</el-dropdown-item>
          <el-dropdown-item command='modify_perm' v-if='contextMenuType===3'>修改此权限</el-dropdown-item>
          <el-dropdown-item command='delete_perm' v-if='contextMenuType===3'>删除此权限</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
  
</template>

<script>
var that
export default {
  props: {
    data: {},
    props: {},
    height: {
      default: 'auto'
    }
  },
  data() {
    return {
      // 右键点击 node 时，获取的数据
      nodeData: {},
      addMenu: {
        pid: null,
        url: '/menu/add',
        title: '新增菜单'
      },
      modifyMenu: {
        id: null,
        name: null,
        type: null,
        ord: null,
        url: '/menu/modify',
        title: '修改菜单'
      },
      deleteMenu: {
        id: null,
        name: null,
        url: '/menu/delete'
      },
      addPerm: {
        menu_id: null,
        title: '新增权限',
        url: '/permission/add'
      },
      modifyPerm: {
        id: null,
        name: null,
        menu_id: null,
        type: null,
        key: null,
        title: '修改权限',
        url: '/permission/modify'
      },
      deletePerm: {
        id: null,
        name: null,
        url: '/permission/delete'
      },
      elDropdown: null,
      filterText: '',
      contextMenuType: null
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    showContexmenu: (event, obj, node, component) => {
      // 1: 一级菜单   2: 子菜单   3: 权限
      that.contextMenuType = node.level

      let container = that.$refs.tree.$parent.$parent.$parent.$el.children[0]
      let scrollTop = that.Util.getScrollTop(container)
      
      that.elDropdown.style.zIndex = 999
      that.elDropdown.style.top = event.y - 170 + scrollTop + 'px'
      that.elDropdown.style.left = event.x - 200 + 'px'
      
      that.nodeData = obj
    },
    handleCheck: () => {
      // let nodeList = nodes.checkedNodes
    },
    handleDropdownVC: isShow => {
      if (!isShow) {
        that.elDropdown.style.zIndex = -999
      }
    },
    handleContextMenu: command => {
      let emitObj = {}

      if (command === 'add_menu') {
        that.addMenu.pid = that.nodeData.pid
        that.modifyMenu.ord = that.nodeData.ord
        emitObj = that.addMenu

      } else if (command === 'add_submenu') {
        that.addMenu.pid = that.nodeData.id
        that.modifyMenu.ord = that.nodeData.ord
        emitObj = that.addMenu

      } else if (command === 'modify_menu') {
        that.modifyMenu.id = that.nodeData.id
        that.modifyMenu.name = that.nodeData.name
        that.modifyMenu.type = that.nodeData.type
        that.modifyMenu.ord = that.nodeData.ord
        emitObj = that.modifyMenu

      } else if (command === 'delete_menu') {
        that.deleteMenu.id = that.nodeData.id
        that.deleteMenu.name = that.nodeData.name
        emitObj = that.deleteMenu

      } else if (command === 'add_perm') {
        that.addPerm.menu_id = that.nodeData.id
        emitObj = that.addPerm
      
      } else if (command === 'modify_perm') {
        that.modifyPerm.id = that.nodeData.id
        that.modifyPerm.menu_id = that.nodeData.menu_id
        that.modifyPerm.type = that.nodeData.type
        that.modifyPerm.name = that.nodeData.name
        that.modifyPerm.key = that.nodeData.key
        emitObj = that.modifyPerm

      } else if (command === 'delete_perm') {
        that.deletePerm.id = that.nodeData.id
        that.deletePerm.name = that.nodeData.name
        emitObj = that.deletePerm
      }

      that.$emit('clickMenu', emitObj)
      
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    }
  },
  mounted() {
    that = this
    that.elDropdown = that.$refs.dropdown.$el
    
  }
}
</script>

<style scoped>
.el-dropdown
{
  position: absolute;
  z-index: -999;
  width: 80px;
  top: 0;
  left: 0;
}
.el-dropdown-link
{
  display: inline-block;
  width: 100%;
  height: 25px;
}
[role=treeitem]
{
  color: red!important;
}
</style>



// WEBPACK FOOTER //
// src/components/cx/cxTreeCheckbox.vue